import React from "react";
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  kicker,
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-250" data-mp="3f2n73y24osr0">
      {kicker && <p className={`text-sm font-bold uppercase tracking-wider ${dark ? "text-gold" : "text-brand"}`} data-id="element-251" data-mp="3k187bxhdrcfg">
          {kicker}
        </p>}
      <h2 className={`mt-2 font-display text-[30px] font-extrabold leading-[1.1] sm:text-4xl lg:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-252" data-mp="bmgcsi5ls7uw">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-[17px] leading-relaxed sm:text-lg ${dark ? "text-white/80" : "text-ink-soft"}`} data-id="element-253" data-mp="6tdjmb4qn0f8">
          {subtitle}
        </p>}
    </div>;
}